<template>
  <div class="product">
    <Header :class="{ hidden: isHidden }"></Header>
    <div class="we-product AlimaBold fs230 fcF5F5F5">
      Our Products
      <div class="title my600 fs60 fc000000">
        我们的产品
        <div class="title-line"></div>
      </div>
      <img src="@/assets/img/index/line1.png" class="line1-img" alt="" />
    </div>
    <div class="calendar">
      <div class="calendar-left">
        <div class="spirit-blue" @wheel="onScroll">
          <div
            class="circle blue"
            :style="{ transform: `translateY(${offsetY}px)` }"></div>
        </div>
        <div class="calendar-logo">
          <img src="@/assets/logo.svg" class="logo2-img" alt="" />
        </div>
        <!-- <div class="calendar-title my600 fs44 fc000000">千里知行</div> -->
        <!-- <div class="calendar-desc my600 fs32 fc000000">今日宜开心！</div> -->
        <div class="calendar-characteristic">
          <div class="character-title my600 fs20 fc000000">产品特色:</div>
          <div class="character-desc my400 fs20 fc000065">
            基于文化的新媒体。

          </div>
        </div>
        <div class="calendar-introduce">
          <div class="character-title my600 fs20 fc000000">产品简介: </div>
          <div class="character-desc my400 fs20 fc000065">
            打破流量茧房的单一视角，赋能用户自主追溯文化源头，推进中华文化的伟大复兴。
          </div>
        </div>
        <div class="calendar-app">
          <div class="app-ios my400 fs16 fc000000">
            <img src="@/assets/icon/apple.svg" class="apple-logo" alt="" />
            IOS版
          </div>
          <!-- <div class="app-android">
            <img src="@/assets/icon/android.svg" class="android-logo" alt="" />
            Android版
          </div> -->
        </div>
      </div>
      <div class="calendar-right">
        <img src="@/assets/img/product/product.png" class="product-img" alt="" />
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script setup>
  import Header from "@/components/Header.vue";
  import Footer from "@/components/Footer.vue";
  import { ref, onMounted, onBeforeUnmount } from "vue";

  const isHidden = ref(false);
  let lastScrollTop = 0;

  // 控制圆圈浮动的偏移值
  const offsetY = ref(0);

  const MAX_OFFSET = 80; // 最大浮动像素
  const STEP = 30; // 每次滚动浮动步长

  const onScroll = (event) => {
    if (event.deltaY > 0) {
      // 向下滚动
      offsetY.value = Math.min(offsetY.value + STEP, MAX_OFFSET);
    } else {
      // 向上滚动
      offsetY.value = Math.max(offsetY.value - STEP, -MAX_OFFSET);
    }
  };

  const handleScroll = () => {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    if (currentScroll > lastScrollTop && currentScroll > 60) {
      isHidden.value = true; // 下滑：隐藏
    } else {
      isHidden.value = false; // 上滑：显示
    }

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  };

  onMounted(() => {
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("wheel", onScroll);
  });

  onBeforeUnmount(() => {
    window.removeEventListener("scroll", handleScroll);
    window.removeEventListener("wheel", onScroll);
  });
</script>
<style lang="less" scoped>
  .product {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;

    .we-product {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      position: relative;
      margin: 170px auto 0;
      left: -220px;
      width: 1460px;
      height: 180px;

      .title {
        position: absolute;
        left: 179px;
        top: 0;
        width: 300px;
        .title-line {
          margin-top: -25px;
          width: 300px;
          height: 24px;
          background: #d3fea3;
        }
      }

      .line1-img {
        position: absolute;
        right: -130px;
        bottom: -220px;
        width: 185px;
        height: 470px;
      }
    }

    .calendar {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin: 0 auto;
      margin-top: 100px;
      margin-bottom: 100px;
      width: 1540px;
      height: 705px;

      .calendar-left {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        position: relative;
        width: 640px;
        height: 660px;
        margin-top: 80px;

        .spirit-blue {
          position: absolute;
          left: -300px;
          top: 30px;
          z-index: -1;
          width: 500px;
          height: 500px;

          .circle {
            border-radius: 50%;
            opacity: 0.6;
            pointer-events: none;
            transition: transform 2.3s ease;
          } 

          .blue {
            width: 100%;
            height: 100%;
            background: radial-gradient(circle, rgba(0, 123, 255, 0.2));
          }
        }

        .calendar-logo {
          width: 100px;
          height: 100px;
          border-radius: 24px;
          // border: 1px solid #dddddd;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;

          .logo2-img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }

        .calendar-title {
          margin-top:50px;
        }

        .calendar-characteristic {
          margin-top: 50px;

          .character-desc {
            margin-top: 20px;
          }
        }

        .calendar-introduce {
          margin-top: 50px;

          .character-desc {
            margin-top: 18px;
            width: 726px;
            text-align: justify;
          }
        }

        .calendar-app {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          margin-top: 48px;
          width: 304px;
          height: 44px;

          .app-ios {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            width: 139px;
            height: 44px;
            border-radius: 22px 22px 22px 22px;
            border: 1px solid #000000;
            cursor: pointer;

            .apple-logo {
              margin: 0 24px 0 16px;
              width: 24px;
              height: 24px;
            }
          }

          .app-android {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            width: 139px;
            height: 44px;
            border-radius: 22px 22px 22px 22px;
            border: 1px solid #000000;
            cursor: pointer;

            .android-logo {
              margin: 0 8px 0 12px;
              width: 30px;
              height: 30px;
            }
          }
        }
      }

      .calendar-right {
        flex-shrink: 0;
        width: 700px;
        margin-left: 200px;

        .product-img {
          display: block;
          width: 100%;
          height: auto;
        }
      }
    }
  }
</style>
